import NewsForm from "./NewsForm";

// View: Modal Component with NewsForm
const NewsAddModal = ({ isOpen, onClose, onSubmit, initialData }) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-auto">
      <div className="bg-white p-6 rounded-lg w-[700px] max-h-[80vh] overflow-y-auto">
        <NewsForm onSubmit={onSubmit} initialData={initialData} onClose={onClose} />
      </div>
    </div>
    
    );
  };

export default NewsAddModal
